module.exports = __webpack_public_path__ + "img/collection-diamondJewelry025Carat.7bc1add.jpg";